
import {
  commonModule,
  companyModule,
  dashboardModule,
  installationsModule,
  itemsModule,
  tasksModule,
} from "@/store/modules/store-accessor";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { TimeUtil } from "@/helpers/TimeUtil";
import {
  taskColor,
  getOptimalTextColor,
  formatOnlyDate,
  formatDateWithoutSeconds,
  mergedAddressAndArea,
  priorityIcon,
} from "@/helpers/data";
import { openInstallationSideview } from "@/helpers/installationSideview";

@Component
export default class DashboardPendingTasksTable extends Vue {
  @Prop() readonly headers: any;
  @Prop() readonly items: any;
  @Prop() readonly search: string;
  @Prop() readonly isLoading: boolean;

  formatDate(item: Record<string, any>) {
    if (!item.due_at) {
      return "-";
    }
    if (item.all_day) {
      return formatOnlyDate(item.due_at);
    }
    return formatDateWithoutSeconds(item.due_at);
  }

  hasSpace(note: string) {
    if (note) {
      return note.trim().includes(" ");
    } else {
      return false;
    }
  }

  dateToColor(task: Record<string, any>) {
    return taskColor(task);
  }

  optimalTextColor(color: string) {
    return getOptimalTextColor(color);
  }

  maxWordSize(note: string) {
    if (note) {
      let words = note.split(" ");
      return Math.max(...words.map((el) => el.length));
    } else {
      return 0;
    }
  }

  setMergedAddressAndArea(address: string, area: string) {
    return mergedAddressAndArea(address, area);
  }

  async openInstallationSideViewOrTaskModal(task: any) {
    if (!task.installation_id) {
      dashboardModule.setIsLoadingPendingTasks(true);
      tasksModule.unsetCurrentTask();
      await tasksModule.getTaskDetails(task.id);
      commonModule.showModal({ name: "open-orphan-task-modal" });
      dashboardModule.setIsLoadingPendingTasks(false);
    } else {
      try {
        dashboardModule.setIsLoadingPendingTasks(true);
        await openInstallationSideview({
          installationId: task.installation_id,
          tab: 'tasks',
          taskId: task.id,
        });
      } catch (error) {
        // Sideview open failed (e.g. installation deleted).
      } finally {
        dashboardModule.setIsLoadingPendingTasks(false);
      }
    }
  }

  nameText(item: Record<string, any>) {
    return item.name?.trim() ? `${item.name}` : '-';
  }

  taskItemDescription(item: Record<string, any>) {
    const installationItemDescriptionIsEnabled = (companyModule.company?.preferences as any)?.installation_item_description;

    return item.item_description ? `${item.item_description} | ` : '';

  }

  priorityIcon(name: string) {
    return priorityIcon(name);
  }

}
